import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputRef", "showError", "value"];
import { memo, useCallback, useMemo, useState } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UITextInput from 'UIComponents/input/UITextInput';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { domainContainsPath, isValidDomain, getDomainPathInfo, domainContainsProtocol, getDomainProtocolInfo } from '../../validation/PropertyValidations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DomainInput = _ref => {
  let {
      inputRef,
      showError,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [blurred, setBlurred] = useState(false);
  const propertyValue = value == null ? '' : `${value}`;
  const handleBlur = useCallback(() => {
    setBlurred(true);
  }, []);
  const handleFocus = useCallback(() => {
    setBlurred(false);
  }, []);
  const shouldShowError = useMemo(() => showError && blurred && propertyValue && (!isValidDomain(propertyValue) || domainContainsPath(propertyValue) || domainContainsProtocol(propertyValue)), [showError, blurred, propertyValue]);
  const validationError = useMemo(() => {
    if (!shouldShowError) {
      return null;
    }
    const {
      path,
      domain
    } = getDomainPathInfo(propertyValue);
    const {
      protocol
    } = getDomainProtocolInfo(propertyValue);
    if (protocol && path) {
      return /*#__PURE__*/_jsx("div", {
        className: "is--text--error",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyDomain.error.invalidDomainBoth",
          options: {
            domain,
            protocol,
            path
          }
        })
      });
    }
    if (protocol) {
      return /*#__PURE__*/_jsx("div", {
        className: "is--text--error",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyDomain.error.invalidProtocol",
          options: {
            domain,
            protocol
          }
        })
      });
    }
    if (path) {
      return /*#__PURE__*/_jsx("div", {
        className: "is--text--error",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyDomain.error.invalidPath",
          options: {
            domain,
            path
          }
        })
      });
    }
    return /*#__PURE__*/_jsx("div", {
      className: "is--text--error",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataProperties.PropertyDomain.error.invalidDomain",
        options: {
          domain: propertyValue
        }
      })
    });
  }, [shouldShowError, propertyValue]);
  return /*#__PURE__*/_jsxs(UIGridItem, {
    size: {
      xs: 12
    },
    className: "p-x-0",
    children: [/*#__PURE__*/_jsx(UITextInput, Object.assign({}, rest, {
      inputRef: inputRef,
      value: propertyValue,
      onBlur: handleBlur,
      onFocus: handleFocus
    })), validationError]
  });
};
export default /*#__PURE__*/memo(DomainInput);